import { RawTextInput } from '@festina-life/ui/forms'
import { TreeButtons } from '@festina-life/ui/listsAndTables'
import { Icon } from '@festina-life/ui/structure'
import { type ChangeEvent, useEffect, useEffectEvent, useState } from 'react'
import { useLocation } from 'react-router'

import { ServerConfigurationItems } from '../../scenes/serverConfigurationItems/ServerConfigurationItems'
import { useConfigurationItemsTree } from '../../scenes/serverConfigurationItems/useConfigurationItemsTree'
import { useConfigurationItemsTreeId } from '../../scenes/serverConfigurationItems/useConfigurationItemsTreeId'
import { ConfigurationItemsFilterMenu } from './ConfigurationItemsFilterMenu'
import { type FilterStatus, initialFilterStatus } from './types'
import { useActiveConfigurationPath } from './useActiveConfigurationPath'
import { useOpenConfigurationPath } from './useOpenConfigurationPath'

type Props = {
  isVisible: boolean
}

export const ConfigurationItemsTree = ({ isVisible }: Props) => {
  const location = useLocation()
  const configurationItemsId = useConfigurationItemsTreeId()
  const [query, setQuery] = useState('')
  const [filterStatus, setFilterStatus] =
    useState<FilterStatus>(initialFilterStatus)
  const configurationItemsTree = useConfigurationItemsTree({
    filterStatus,
    shouldShowEmptyNodes: filterStatus.showEmptyLayers,
    shouldIncludeLayers: true,
  })
  const { layer, packageName } = useActiveConfigurationPath()
  const handleFilterQueryChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }
  const openConfigurationPath = useOpenConfigurationPath()
  const doOpenConfigurationPath = useEffectEvent(openConfigurationPath)

  useEffect(() => {
    if (isVisible) {
      doOpenConfigurationPath(layer, packageName)
    }
  }, [isVisible, layer, packageName, location.pathname])

  return (
    <>
      <div className="flex flex-row items-center gap-x-2 p-2">
        <RawTextInput
          value={query}
          onChange={handleFilterQueryChanged}
          addOnProps={{
            element: <Icon name="MagnifyingGlass" />,
          }}
        />
        <ConfigurationItemsFilterMenu
          filterStatus={filterStatus}
          onFilterStatusChanged={setFilterStatus}
        />
        <TreeButtons nodes={configurationItemsTree} id={configurationItemsId} />
      </div>
      <ServerConfigurationItems
        tree={configurationItemsTree}
        query={query}
        isVisible={isVisible}
      />
    </>
  )
}
